import { UploadOutlined } from '@ant-design/icons';
import { Avatar, Button, Card } from 'antd';
import { VIETNAM_PLATFORM_ID } from 'constants/constant';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './FileUploadCard.css';

const { Meta } = Card;

const FileUploadCard: React.FC<{ platformId: number }> = ({ platformId }) => {
  const navigate = useNavigate();
  const directUploadPath = platformId === VIETNAM_PLATFORM_ID ? '/assets/add-vn' : '/assets/add';
  return (
    <div>
      <Card hoverable className="custom-card" style={{ width: '100%', marginBottom: '16px' }}>
        <div className="card-content">
          <Meta
            avatar={
              <Avatar
                size={48}
                style={{ backgroundColor: '#f6f6f6' }}
                icon={<UploadOutlined style={{ color: 'black' }} />}
              />
            }
            title={<span className="upload-description">{'Upload Video'}</span>}
          />
          <div className="buttons-container">
            {
              <>
                <Button onClick={() => navigate(directUploadPath)}>Direct Upload</Button>
                {platformId === 1 && (
                  <Button onClick={() => navigate('/assets-source')}>SFTP Upload</Button>
                )}
                {/* <Button onClick={() => navigate('/assets')}>Manage Video</Button> */}
              </>
            }
          </div>
        </div>
      </Card>
    </div>
  );
};

export default FileUploadCard;
